export const CHART_OF_ACCOUNT_VISIBILITY_STATES = Object.freeze({
  hidden: 'Unsichtbar',
  standard: 'Kontenliste Standard',
  extended: 'Kontenliste Erweitert',
})

export const CHART_OF_ACCOUNT_VISIBILITY_STATES_EN = Object.freeze({
  hidden: 'hidden',
  standard: 'standard',
  extended: 'extended',
})

export const CHART_OF_ACCOUNT_SKR_TYPE = Object.freeze({
  unknown: 'unknown',
  skr03: 'skr03',
  skr04: 'skr04',
})
